import {listRolesQueryOptions} from "@project/application/access-administration";
import {AppErrorBoundary} from "@project/layouts";
import {createFileRoute} from "@tanstack/react-router";
import {RolesPage} from "./-page/roles.page";
import {RolesPending} from "./-page/roles.pending";
import {listRolesSearchSchema} from "./-types";

export const Route = createFileRoute("/_app/user-management/users/roles/")({
  validateSearch: listRolesSearchSchema,
  loaderDeps: ({search}) => search,
  loader: ({context: {queryClient}, deps, cause}) => {
    if (cause === "enter") return queryClient.ensureQueryData(listRolesQueryOptions(deps));
    void queryClient.prefetchQuery(listRolesQueryOptions(deps));
    return;
  },
  component: RolesPage,
  errorComponent: AppErrorBoundary,
  pendingComponent: RolesPending,
  staticData: {meta: {breadcrumbs: {hide: true}}},
});
